// AuthMiddleware.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from '@auth0/auth0-react';

const Authmiddleware = (props) => {
  const { isAuthenticated, isLoading } = useAuth0();
  
  // Check if user is authenticated either through Auth0 or local storage
  const hasLocalAuth = localStorage.getItem("authUser");
  
  // Show loading state while Auth0 is initializing
  if (isLoading) {
    return (
      <div className="page-content">
        <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated && !hasLocalAuth) {
    return <Navigate to="/login" />;
  }

  // Render children if authenticated
  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Authmiddleware;